import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { playSound, speak } from '../utils/sounds';

const SubjectSelection = () => {
  const navigate = useNavigate();
  const [selectedSubject, setSelectedSubject] = useState(null);
  const hasSpokenRef = React.useRef(false);

  useEffect(() => {
    // Éviter de parler deux fois à cause du React Strict Mode
    if (!hasSpokenRef.current) {
      speak('Choisis ta matière préférée !');
      hasSpokenRef.current = true;
    }
  }, []);

  const subjects = [
    {
      id: 'lecture',
      name: 'Lecture',
      icon: '📖',
      color: 'linear-gradient(135deg, #56CCF2 0%, #2F80ED 100%)',
      description: 'Apprends à lire les sons',
      exercises: [
        { level: 1, name: 'Prononce 2 lettres' },
        { level: 2, name: 'Prononce 3 lettres' }
      ]
    },
    {
      id: 'ecriture',
      name: 'Écriture',
      icon: '✏️',
      color: 'linear-gradient(135deg, #F2C94C 0%, #F2994A 100%)',
      description: 'Reconnais les mots',
      exercises: [
        { level: 1, name: 'Mots de 2 lettres' },
        { level: 2, name: 'Mots de 3 lettres' }
      ]
    },
    {
      id: 'math',
      name: 'Mathématiques',
      icon: '🔢',
      color: 'linear-gradient(135deg, #BB6BD9 0%, #9B51E0 100%)',
      description: 'Compte et calcule',
      exercises: [
        { level: 1, name: 'Ajouter ou soustraire 1' },
        { level: 2, name: 'Ajouter ou soustraire 2' },
        { level: 3, name: 'Reconnaître les nombres 0-20' },
        { level: 4, name: 'Reconnaître les nombres 20-40' },
        { level: 5, name: 'Reconnaître les nombres 40-60' },
        { level: 6, name: 'Ajouter ou soustraire 1 ou 2' },
        { level: 7, name: 'Chiffre avant ou après' },
        { level: 8, name: 'Compter de 0 à 69', special: 'counting' },
        { level: 9, name: 'Compter de 69 à 0', special: 'counting-down' },
        { level: 10, name: 'Comparer des collections', special: 'collection-comparison' }
      ]
    },
    {
      id: 'poesie',
      name: 'Poésie',
      icon: '🎭',
      color: 'linear-gradient(135deg, #FF6B9D 0%, #C44569 100%)',
      description: 'Récite des poésies',
      exercises: [
        { level: 1, name: 'Jour pluvieux d\'automne' }
      ]
    }
  ];

  const handleSubjectClick = (subject) => {
    playSound('click');
    setSelectedSubject(subject.id === selectedSubject ? null : subject.id);
    speak(subject.name);
  };

  const handleExerciseClick = (subjectId, level, special) => {
    playSound('click');
    if (special === 'counting') {
      navigate('/counting');
    } else if (special === 'counting-down') {
      navigate('/counting-down');
    } else if (special === 'collection-comparison') {
      navigate('/collection-comparison');
    } else {
      navigate(`/${subjectId}/${level}`);
    }
  };

  return (
    <div>
      <div className="header">
        <h1>🎯 Choisis ta matière</h1>
      </div>

      <div className="grid grid-3">
        {subjects.map((subject) => (
          <div key={subject.id}>
            <div
              className={`card ${selectedSubject === subject.id ? 'bounce' : ''}`}
              style={{
                cursor: 'pointer',
                background: selectedSubject === subject.id ? 'white' : 'white',
                transform: selectedSubject === subject.id ? 'scale(1.05)' : 'scale(1)',
                transition: 'all 0.3s ease'
              }}
              onClick={() => handleSubjectClick(subject)}
            >
              <div style={{ fontSize: '5rem', marginBottom: '20px' }}>
                {subject.icon}
              </div>
              <h2 style={{
                background: subject.color,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: '2.5rem',
                marginBottom: '15px'
              }}>
                {subject.name}
              </h2>
              <p style={{ fontSize: '1.2rem', color: '#666', marginBottom: '20px' }}>
                {subject.description}
              </p>

              {selectedSubject === subject.id && (
                <div style={{ marginTop: '20px' }}>
                  {subject.exercises.map((exercise) => (
                    <button
                      key={exercise.level}
                      className="btn"
                      style={{
                        background: subject.color,
                        color: 'white',
                        width: '100%',
                        marginBottom: '10px',
                        fontSize: '1.2rem',
                        padding: '15px'
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleExerciseClick(subject.id, exercise.level, exercise.special);
                      }}
                    >
                      {exercise.name}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <button
          className="btn btn-warning"
          onClick={() => navigate('/')}
        >
          🏠 Retour
        </button>
      </div>
    </div>
  );
};

export default SubjectSelection;
